import { useCallback, useState } from "react";
import { useUpdateMerchantLogo } from "../../../../hooks/queries/useMerchantQueries";
import { toastService } from "../../../../providers";


const useLogoUploadHandler = () => {
  const [logoModalOpen, setLogoModalOpen] = useState(false);

  const { mutate: updateLogo, isPending: updatingLogo } =
    useUpdateMerchantLogo();

  const handleCloseLogoModal = useCallback(() => {
    setLogoModalOpen(false);
  }, []);

  const handleOpenLogoModal = useCallback(() => {
    setLogoModalOpen(true);
  }, []);

  const handleLogoSubmit = ({ logoBase64, contentType }) => {
    if (!logoBase64) return;

    updateLogo(
      {
        logoBase64,
        contentType,
      },
      {
        onSuccess: () => {
          toastService.success("Logo updated successfully!");
          setLogoModalOpen(false);
        },
        onError: (_err) => {
          toastService.error("Failed to update logo");
        },
      },
    );
  };

  return {
    logoModalOpen,
    handleCloseLogoModal,
    handleOpenLogoModal,
    handleLogoSubmit,
    isSubmitting: updatingLogo,
  };
};

export default useLogoUploadHandler;
